<template>
  <div v-if="daysLeft !== null && daysLeft >= 0 && planLabel=='trial'" class="w-full bg-red-600 text-white text-center py-2 font-semibold top-0 left-0 z-50">
    Il vous reste {{ daysLeft }} jour{{ daysLeft === 1 ? '' : 's' }} d'essai gratuit.
  </div>
</template>

<script>
import { auth, db } from '@/firebase'
import { doc, getDoc } from 'firebase/firestore'
import { getPlanName } from '@/plans'

export default {
  data() {
    return {
      daysLeft: null,
      planLabel: ''
    }
  },
  async mounted() {
    this.planLabel = await getPlanName();
    console.log("Plan label:", this.planLabel);
    if (auth.currentUser) {
      const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid))
      if (userDoc.exists() && userDoc.data().createdAt) {
        const createdAt = userDoc.data().createdAt.toDate()
        const now = new Date()
        const diffMs = now - createdAt
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
        this.daysLeft = 30 - diffDays
      }
    }
  }
}
</script>